/**
 * Sentinel prefix returned by getPrefixFromPath when the error path is null
 * (e.g. network errors). Used in mergeExpectedErrors to ensure global expected
 * error codes are checked against path-less errors in composition queries.
 */
export const NOT_FOUND_PREFIX = 'not-found-prefix';
